<template>
  <div class="register-step">
    <!-- v-if="success" -->
    <div v-if="registerOK">
      <div id="exito" :class="animationclass" style="justify-content:center;">
        <div>
          <p
            v-html="
              getText(
                'register.step4.text1',
                'Perfecto, el registro ha terminado'
              )
            "
          ></p>
          <div id="loader-container" style="text-align:center; margin-top: 30%">
            <Loader> </Loader>
          </div>
          <p>
            <a
              @click="gotoNextPage"
              v-html="
                getText(
                  'register.step4.text2',
                  'Te redirigimos a la página principal'
                )
              "
            >
            </a>
          </p>
        </div>
      </div>

    </div>

      <!--  <div id="waiting" v-else class="register-step">
        Ya casi hemos terminado

        Te falta sólo hacer click en el enlace en el correo electrónico que te hemos enviado.

        Esperando la verificación del correo electrónico...
      </div> -->
  
   <!--   <div v-else>
     no exito 
      <p
        v-html="
          getText(
            'register.step4.textwrong1',
            ' Lo sentimos tu perfil no ha podido ser validado. Estamos realizando una comprobación manual y te avisaremos próximamente'
          )
        "
      ></p>
      <ul>
        <li>
          <a
            @click="EditProfileAgain"
            v-html="
              getText(
                'register.step4.textwrong2',
                'Volver a intentar editar tus datos de colegiado'
              )
            "
          >
          </a>
        </li>
        <li v-if="getConfigParam('register.hasdemo')">
          <a @click="backToDemo"> Probar el modo demo </a>
        </li>
      </ul>
    </div> -->
  </div> 
</template>
<script>
import Loader from '../UI/Loader.vue'
import { RegisterStepMixin } from '../mixins/RegisterStepMixin'
import { ToolsMixin } from '../mixins/ToolsMixin'

export default {
  name: 'RegisterStep4',
  mixins: [RegisterStepMixin, ToolsMixin],
  components: {
    Loader
  },
  data: () => ({
    returnDataString: '',
    //registerOK: true
  }),
  computed: {
    animationclass() {
      return 'slide-out-blurred-top'
    },
    // success() {
    //   if (
    //     this._.has(
    //       this.$store.state.auth.loginResponse,
    //       'data.user.statuses.doctor.code'
    //     )
    //   ) {
    //     if (
    //       this.$store.state.auth.loginResponse.data.user.statuses.doctor.code ==
    //       1
    //     ) {
    //       this.$matomo.trackEvent(this.generateMatomoEventCategory(), 'Step 6', 'Sucess')
    //       return true
    //     }
    //   }
    //   this.$matomo.trackEvent(this.generateMatomoEventCategory(), 'Step 6', 'Fail')
    //   return false
    // }
    registerOK() {
      if (
        this._.has(
          this.$store.state.auth.loginResponse,
          'data.user.statuses.doctor.code'
        )
      ) {
        if (
          this.$store.state.auth.loginResponse.data.user.statuses.doctor.code ==
          1
        ) {
          this.$matomo.trackEvent(this.generateMatomoEventCategory(), 'Step 6', 'Sucess')
          return true
        }
      }
      this.$matomo.trackEvent(this.generateMatomoEventCategory(), 'Step 6', 'Fail')
      return true
    }
  },
  methods: {
    backToDemo() {
      this.$router
        .push(this.getConfigParam('register.demopath', '/demo'))
        .catch(error => {
          console.info(error.message)
        })
    },
    EditProfileAgain() {
      this.$store.commit('register/prevStep')
      this.$store.commit('register/prevStep')
    },
    gotoNextPage() {
      if (this.isApp) {
        window.location.href = 'tokmed://register/ok'
      } else {
        window.location.href = this.$store.getters[
          'decoupled/getProperConfig'
        ].nexturl
      }
    },
    returnDataObjectMethod() {
      return {
        data: this.$store.state.auth.loginResponse.data,
        registerinfo: { premiumcode: this.$store.state.register.premiumCode }
      }
    }
  },
  created() {
    //this.$store.dispatch('auth/login',  { 'email':this.$store.state.register.mail, 'password': this.$store.state.register.pass })
    window.getResponseDataObject = this.returnDataObjectMethod
  //   if (this.success)
  //     this.timer = setTimeout(() => {
  //       this.gotoNextPage()
  //     }, 3500)
  // }
  if (this.registerOK)
      this.timer = setTimeout(() => {
        this.gotoNextPage()
      }, 3500)
  }
}
</script>
<style lang="less" scoped>
.slide-out-blurred-top {
  -webkit-animation: slide-out-blurred-top 0.45s
    cubic-bezier(0.755, 0.05, 0.855, 0.06) 3s both;
  animation: slide-out-blurred-top 0.45s cubic-bezier(0.755, 0.05, 0.855, 0.06)
    3s both;
}
/* ----------------------------------------------
 * Generated by Animista on 2018-9-11 2:43:53
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation slide-out-blurred-top
 * ----------------------------------------
 */
@-webkit-keyframes slide-out-blurred-top {
  0% {
    -webkit-transform: translateY(0) scaleY(1) scaleX(1);
    transform: translateY(0) scaleY(1) scaleX(1);
    -webkit-transform-origin: 50% 0%;
    transform-origin: 50% 0%;
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateY(-1000px) scaleY(2) scaleX(0.2);
    transform: translateY(-1000px) scaleY(2) scaleX(0.2);
    -webkit-transform-origin: 50% 0%;
    transform-origin: 50% 0%;
    -webkit-filter: blur(40px);
    filter: blur(40px);
    opacity: 0;
  }
}
@keyframes slide-out-blurred-top {
  0% {
    -webkit-transform: translateY(0) scaleY(1) scaleX(1);
    transform: translateY(0) scaleY(1) scaleX(1);
    -webkit-transform-origin: 50% 0%;
    transform-origin: 50% 0%;
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateY(-1000px) scaleY(2) scaleX(0.2);
    transform: translateY(-1000px) scaleY(2) scaleX(0.2);
    -webkit-transform-origin: 50% 0%;
    transform-origin: 50% 0%;
    -webkit-filter: blur(40px);
    filter: blur(40px);
    opacity: 0;
  }
}

#exito {
}
</style>
